'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import I18n from 'I18n';
import Raven from 'raven-js';
import UIPage from 'UIComponents/page/UIPage';
import UIHeader from 'UIComponents/layout/UIHeader';
import UIIcon from 'UIComponents/icon/UIIcon';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UICardSection from 'UIComponents/card/UICardSection';
import { NavMarker } from 'react-rhumb';

const AdBlockDetectedPrompt = () => {
  useEffect(() => {
    // attempts at tracking how often this happens. Note that depending on the ad blocker
    // these may or may not happen successfully.
    Raven.captureMessage('Adblocker detected');
  }, []);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "ADBLOCK_ERROR_PAGE",
    children: /*#__PURE__*/_jsxs(UIPage, {
      bodyClassName: "carded-content",
      children: [/*#__PURE__*/_jsx("div", {
        className: "header-nav-container m-bottom-5",
        children: /*#__PURE__*/_jsx("div", {
          className: "center-content",
          children: /*#__PURE__*/_jsx(UIHeader, {
            title: "Ads",
            fullWidth: true,
            flush: true
          })
        })
      }), /*#__PURE__*/_jsx(UICardWrapper, {
        className: "text-center center-content m-top-9",
        children: /*#__PURE__*/_jsxs(UICardSection, {
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: "warning",
            size: "lg"
          }), /*#__PURE__*/_jsx("h1", {
            children: I18n.text('adblockDetection.title')
          }), /*#__PURE__*/_jsx("p", {
            children: I18n.text('adblockDetection.description')
          })]
        })
      })]
    })
  });
};

export default AdBlockDetectedPrompt;